import { Navigate } from 'react-router-dom';
import { validateUser } from '../../Services/utils';
import { LOGIN } from '../../Constants/routes';

const ProtectedRoute = ({ children }) => {
  const isUserValid = validateUser();
  return isUserValid ? children : <Navigate to={LOGIN} replace />
}

export default ProtectedRoute;